import { css } from "styled-components";
import { FontMixin } from "../../../../../../../../styles/common/mixins/helpers.styled.js";
import { Border, Padding } from "../../../../../../../../styles/common/mixins/logical.styled.js";
const veciAutocompleteStyles = {
    HeaderSuggestionDesktop: ()=>css`
		${FontMixin({
            size: 'base'
        })};
		line-height: 22px;
		${Padding({
            y: '12px'
        })};
		${Border({
            all: '0'
        })};
		color: ${({ theme  })=>theme.colors.grays.dark};
	`,
    IconWrapperDesktop: ()=>css`
		color: ${({ theme  })=>theme.colors.grays.dark};
		${FontMixin({
            height: 'base'
        })};
		font-size: 18px;
		${Padding({
            right: '8px'
        })};
	`,
    LabelSuggestionDesktop: ()=>css`
		--background-color-selected: ${({ theme  })=>theme.colors.green?.lighter};
		--text-color-selected: ${({ theme  })=>theme.colors.green?.darker};
		color: ${({ theme  })=>theme.colors.text.dark};
		${FontMixin({
            height: 'base'
        })};

		${({ $highlight  })=>$highlight && css`
				background-color: var(--background-color-selected);
				color: var(--text-color-selected);
				${FontMixin({
                weight: 'semiBold'
            })};
			`};

		span > strong {
			color: var(--text-color-selected);
		}

		&:hover {
			color: ${({ theme  })=>theme.colors.text.dark};
			background-color: ${({ theme  })=>theme.colors.primary.lightestL};
		}
	`
};
export default veciAutocompleteStyles;

//# sourceMappingURL=veci.js.map